const relativeApiUrl = {
    AUTHENTICATION: "/Authentication",
    ACCOUNT: "/Account",
    PACKAGE: "/Package",
    MODULE: "/Module",
    METRIC: "/Metric",
    SUBCATEGORY: "/SubCategory",
    MAT_ACCOUNT: "/MatAccount",
    ROLE: "/Role",
    SECTOR: "/Sector",
    POWER_BI: "/PowerBi",
    Ticket: "/Ticket",
    ErrorLog:"/ErrorLog",
    Edmart:"/Edmart"
}
export const constantvalues = {
    EDMART_URL:{
      STUDENT_DETAILS: `${relativeApiUrl.Edmart}/student-details`,
    },
    API_URL: {

      //USER CENTRE
      AUTHENTICATE_USER: `${relativeApiUrl.AUTHENTICATION}/authenticate-user`,
      CREATE_ACCOUNT_ADMIN: `${relativeApiUrl.ACCOUNT}/admin`,
      EDIT_ACCOUNT_ADMIN: `${relativeApiUrl.ACCOUNT}/update-account-admin`,
      GET_ACCOUNT_ADMIN: `${relativeApiUrl.ACCOUNT}/account-admin`,
      DELETE_ACCOUNT_ADMIN: `${relativeApiUrl.ACCOUNT}/account-admin`,
      RESET_PASSWORD_FOR_ACCOUNT_ADMIN: `${relativeApiUrl.ACCOUNT}/account-admin/reset-password`,
      FORGOT_PASSWORD_FOR_ACCOUNT_ADMIN: `${relativeApiUrl.ACCOUNT}/account-admin/forgot-password`,
      USER_DETAILS: `${relativeApiUrl.ACCOUNT}/user`,
      SEND_BULK_EMAIL: `${relativeApiUrl.ACCOUNT}/send-bulk-email`,
      DELETE_USER: `${relativeApiUrl.ACCOUNT}/user`,

      GET_USER_PROFERENCE_PROFILE: `${relativeApiUrl.ACCOUNT}/user-preference-profile`,
      SAVE_USER_PROFERENCE_PROFILE: `${relativeApiUrl.ACCOUNT}/user-preference-profile`,
      GET_USER_REPORT_VIEWS: `${relativeApiUrl.ACCOUNT}/user-report-views`,
      SAVE_USER_REPORT_VIEWS: `${relativeApiUrl.ACCOUNT}/user-report-views`,
      DELETE_USER_REPORT_VIEW: `${relativeApiUrl.ACCOUNT}/user-report-view`,
      GET_USER_REPORT_VIEW: `${relativeApiUrl.ACCOUNT}/user-report-view`,
      
      //PACKAGE CENTRE - PACKAGE
      GET_FEATURES: `${relativeApiUrl.PACKAGE}/feature`,
      GET_MODULES: `${relativeApiUrl.PACKAGE}/module`,
      GET_SUBCATEGORIES: `${relativeApiUrl.PACKAGE}/sub-category`,
      GET_METRICS: `${relativeApiUrl.PACKAGE}/metric`,
      CRUD_PACKAGE: `${relativeApiUrl.PACKAGE}/package`,
      PACKAGE: `${relativeApiUrl.PACKAGE}/packageId`,
      PACKAGE_ROOT_URL: `${relativeApiUrl.PACKAGE}`,
      APPROVE_UPGRADE_PACKAGE: `${relativeApiUrl.PACKAGE}/approve-upgrade-package`,
      DECLINE_UPGRADE_PACKAGE: `${relativeApiUrl.PACKAGE}/decline-upgrade-package`,
      CHECK_ACTIVE_REQUEST_EXISTS: `${relativeApiUrl.PACKAGE}/check-active-request`,
      ACTIVE_SUBSCRIPTION: `${relativeApiUrl.PACKAGE}/active-subscription`,

      //PACKAGE CENTRE - PACKAGE
      GET_ALL_MODULES: `${relativeApiUrl.MODULE}/all-modules`,
      GET_ALL_SUBCATEGORIES: `${relativeApiUrl.MODULE}/sub-category`,
      CRUD_MODULE: `${relativeApiUrl.MODULE}/module`,

      //PACKAGE CENTRE - SUBCATEGORY
      CRUD_SUBCATEGORY: `${relativeApiUrl.SUBCATEGORY}/sub-category`,
      GET_METRICS_FOR_SUBCATEGORY: `${relativeApiUrl.SUBCATEGORY}/metrics`,

      //PACKAGE CENTRE - METRICS
      CRUD_METRICS: `${relativeApiUrl.METRIC}/metric`,
      ASSIGNED_PACKAGE: `${relativeApiUrl.MAT_ACCOUNT}/assignedPackage`,

      //MAT ACCOUNT
      GET_ACCOUNT_ADMIN_LIST: `${relativeApiUrl.MAT_ACCOUNT}/account-admin`,
      GET_MAT_ACCOUNT: `${relativeApiUrl.MAT_ACCOUNT}/get-mat-account`,
      CRUD_MAT_ACCOUNT: `${relativeApiUrl.MAT_ACCOUNT}/mat-account`,
      CRUD_MAT_ADMIN: `${relativeApiUrl.MAT_ACCOUNT}/mat-admin`,
      DELETE_MAT_ADMIN: `${relativeApiUrl.ACCOUNT}/mat-admin`,
      SWAP_PACKAGE: `${relativeApiUrl.MAT_ACCOUNT}/swap-package`,
      ADMIN_DETAILS: `${relativeApiUrl.MAT_ACCOUNT}/admin-details`,
      UPLOAD_DOCUMENT: `${relativeApiUrl.MAT_ACCOUNT}/upload-document`,
      REMOVE_UPLOAD_DOCUMENT: `${relativeApiUrl.MAT_ACCOUNT}/remove-uploaded-document`,
      GET_NOTIFICATIONS: `${relativeApiUrl.MAT_ACCOUNT}/notifications`,
      VALIDATE_MAT_ACCOUNT: `${relativeApiUrl.MAT_ACCOUNT}/validate`,
      GET_MAT_ADMIN_MAILIDS: `${relativeApiUrl.MAT_ACCOUNT}/mat-admin-mailIds`,
      ALLOW_CREATE_SCHOOL_USER: `${relativeApiUrl.MAT_ACCOUNT}/active-school-users`,
      CHECK_ACTIVE_ACCESS_REQUEST_EXISTS: `${relativeApiUrl.MAT_ACCOUNT}/check-active-request`,
      CHECK_SCHOOL_TRANSFER_TO_INDIVIDUAL_SCHOOL: `${relativeApiUrl.MAT_ACCOUNT}/check-school-transfer`,

      //SCHOOL
      CRUD_SCHOOL: `${relativeApiUrl.MAT_ACCOUNT}/schools`,
      SCHOOL_UNDER_CLIENT_ACCOUNT: `${relativeApiUrl.MAT_ACCOUNT}/schools-under-clientAccount`,
      SCHOOL_LOGO: `${relativeApiUrl.MAT_ACCOUNT}/schools-logo`,
      INDEPENDENT_SCHOOL: `${relativeApiUrl.MAT_ACCOUNT}/individual-schools`,
      ACTIVATE_INACTIVATE_SCHOOL_USER: `${relativeApiUrl.ACCOUNT}/school-user`,
      RESEND_ACTIVATE_INVITE: `${relativeApiUrl.ACCOUNT}/resend-activation-invite`,
      CRUD_SCHOOL_USER: `${relativeApiUrl.MAT_ACCOUNT}/school-user`,
      GET_SCHOOL_ADMIN_MAILIDS: `${relativeApiUrl.MAT_ACCOUNT}/school-admin-mailIds`,
      RAISE_SCHOOL_TRANSFER_REQUEST: `${relativeApiUrl.MAT_ACCOUNT}/raise-transfer-school-request`,
      TRANSFER_SCHOOL: `${relativeApiUrl.MAT_ACCOUNT}/transfer-school`,

      //ROLE
      CRUD_ROLE: `${relativeApiUrl.MAT_ACCOUNT}/role`,
      ROLE_LIST: `${relativeApiUrl.MAT_ACCOUNT}/roleList`,
      APPROVE_ADD_ROLE_REQUEST: `${relativeApiUrl.MAT_ACCOUNT}/approve-add-role`,
      DECLINE_ADD_ROLE_REQUEST: `${relativeApiUrl.MAT_ACCOUNT}/decline-add-role`,
      ACCESS_LEVELS: `${relativeApiUrl.MAT_ACCOUNT}/access`,

      //SECTOR
      CRUD_SECTOR: `${relativeApiUrl.SECTOR}`,

      //POWER-BI
      POWER_BI: `${relativeApiUrl.POWER_BI}`,
      POWER_BI_GET_REPORT_ITEMS: `${relativeApiUrl.POWER_BI}/powerbi/reports`,
      POWER_BI_GET_CATALOG: `${relativeApiUrl.POWER_BI}/powerbi/catalog`,
      
      //TicketManagement
      CREATE_TICKET: `${relativeApiUrl.Ticket}/create-ticket`,
      GET_ASSIGNED_TICKETS: `${relativeApiUrl.Ticket}/get-assigned-tickets`,
      GET_TICKETS_RAISEDBY_USER: `${relativeApiUrl.Ticket}/get-raised-tickets`,
      DELETE_TICKET: `${relativeApiUrl.Ticket}/delete-ticket`,
      UPDATE_TICKET: `${relativeApiUrl.Ticket}/ticket-status-update`,
      UPLOAD_TICKET_DOCUMENT: `${relativeApiUrl.Ticket}/upload-ticket-document`,

      //REQUEST_TO_VIEW_REPORT
      REQUEST_ACCESS: `${relativeApiUrl.MAT_ACCOUNT}/request-access-to-view-report`,
      GRANT_ACCESS: `${relativeApiUrl.MAT_ACCOUNT}/grant-access-to-view-report`,
      DECLINE_ACCESS: `${relativeApiUrl.MAT_ACCOUNT}/decline-access-to-view-report`,
      
      //Error Log
      GET_ERROR_LOGS: `${relativeApiUrl.ErrorLog}/get-error-logs`,
      GET_TRACE_LOGS: `${relativeApiUrl.ErrorLog}/get-trace-report`,
      GET_MESSAGE_LOGS: `${relativeApiUrl.MAT_ACCOUNT}/get-system-messages-report`,
      SAVE_MESSAGE_LOG: `${relativeApiUrl.MAT_ACCOUNT}/system-message`,
      PREVIEW_MESSAGE: `${relativeApiUrl.MAT_ACCOUNT}/preview-system-message`,
    }
}

export enum MatDialogCloseEvent { SUCCESS = 100, FAILED = 101, CANCELLED = -1, MODIFIED = 102, NAVIGATE = 'navigate', CANCEL = "CANCEL" }

export enum Role { SuperAdmin = "1", AccountAdmin = "2", MatAdmin = "3", SchoolAdmin = "4"}

export enum Controls { 
  Feature="features",
  Package="packages", 
  Module = "modules", 
  SubCategory = "subCategories", 
  Metrics = "metrics"}

export enum Mode { Create = "Create", Edit = "Edit", Delete = "Delete", Preview = "Preview", ChangeStatus = "ChangeStatus", CreateMatAccount = "CreateMatAccount", CreateIndividualSchool = "CreateIndividualSchool", View = "View My Insights" }

export enum DocumentType { ClientAccount = "1", ClientAdmin = "2", School = "3", EntityAudience = "4", Ticket = "5" }

export enum PageKey { 
  AccountAdminCenter="AccountAdminCenter", 
  DataManagementCenter = "DataManagementCenter", 
  UserCenter = "UserCenter", 
  MatAdminDetailsCenter = "MatAdminDetailsCenter", 
  IndependentSchoolCenter = "IndependentSchoolCenter", 
  TicketManagementCenter = "TicketManagementCenter",
  TraceReportCenter = "TraceReportCenter",
  SystemMessagesCentre = "SystemMessagesCentre"
}

export enum LogInProvider {Deesha = "Deesha", M365 = "M365", Google = "Google"}